import { Superstar } from '@shared/icons';
import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import { Coupon } from '../../svg';

type PurchasesStateIconProps = ComponentProps<'div'> & {
  tone?: 'default' | 'accent';
};

function PurchasesStateIcon({ className, tone = 'default', ...props }: PurchasesStateIconProps) {
  const starClasses = tone === 'accent' ? 'text-accent-green' : 'text-foreground-subtle';

  return (
    <div className={twMerge('relative size-16 flex items-center justify-center', className)} {...props}>
      <Superstar className={twMerge('size-16 opacity-40', starClasses)} />
      <Coupon className="absolute top-3 left-1/2 h-10 w-11 -translate-x-1/2 text-foreground dark:text-foreground-inverse" />
    </div>
  );
}

export { PurchasesStateIcon };
